import { useContext, useState, useMemo } from 'react';
import ItemTotals from './ItemTotals';
import SimpleTable from '../../SimpleTable';
import { QAStoreContext } from './QAStore';
import { Spinner } from 'react-bootstrap';

const ItemChecklist = ({ productList }) => {
  const qaStore = useContext(QAStoreContext);
  const config = qaStore.currentConfig[0];
  const [filterInvalid, setFilterInvalid] = useState(false);
  const { hasFFD, hasGBImport } = config.documents;

  const tableData = useMemo(
    () => ({
      headings: [
        {
          label: 'Item',
          key: 'item',
        },
        {
          label: 'Valid',
          key: 'valid',
        },
        {
          label: 'HS Code',
          key: 'hsCode',
        },
        {
          label: 'Origin',
          key: 'origin',
        },
        {
          label: 'Packages',
          key: 'packages',
        },
        {
          label: 'Gross (Kg)',
          key: 'grossKg',
        },
        {
          label: 'Net (Kg)',
          key: 'netKg',
        },
        {
          label: hasFFD || hasGBImport ? 'Customs Value (GBP)' : 'Value',
          key: hasFFD || hasGBImport ? 'customsValue' : 'value',
        },
        {
          label: 'Preference',
          key: 'preference',
          hide: config.hideItemColumns.preference,
        },
        {
          label: 'Duty Liability (GBP)',
          key: 'dutyLiability',
          hide: config.hideItemColumns.dutyLiability,
        },
        {
          label: 'VAT Liability (GBP)',
          key: 'vatLiability',
          hide: config.hideItemColumns.vatLiability,
        },
        {
          label: 'Tariff',
          key: 'tariff',
          hide: config.hideItemColumns.tariff,
        },
      ],
      values: productList.filter((item) => !filterInvalid || item.hasError),
      enableFilterCheckbox: productList.filter((item) => item.hasError).length > 0,
    }),
    [productList, filterInvalid, config]
  );

  return (
    <>
      {productList.length > 0 ? (
        <>
          <div className="qa-item-section">
            <h3 className="qa-section-header">Item Totals</h3>
            <ItemTotals />
          </div>
          <div className="qa-item-section position-relative">
            <div
              className="position-absolute w-100 d-flex align-items-center gap-1 user-select-none justify-content-end"
              style={{ top: -4 }}
            >
              <input
                type="checkbox"
                id="filterInvalid"
                value={filterInvalid}
                disabled={!tableData?.enableFilterCheckbox}
                onChange={(e) => setFilterInvalid(e.target.checked)}
                className="cursor-pointer"
              />
              <label htmlFor="filterInvalid" className="small cursor-pointer">
                Filter for invalid items
              </label>
            </div>

            <h3 className="qa-section-header">Items</h3>
            <SimpleTable data={tableData} dataTestIdPrefix="items" />
          </div>
        </>
      ) : (
        <div className="text-center">
          <Spinner animation="border" role="status" style={{ color: '#0e2554' }}>
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}
    </>
  );
};

export default ItemChecklist;
